import {centerCrop, makeAspectCrop} from "react-image-crop";

/**
 * Параметр aspect для react-image-crop (makeAspectCrop / prop aspect) = ширина/высота рамки кропа.
 * Совпадает с Image.initCanvas «без полей».
 * Альбомный кадр → h_mm/w_mm (печать в «альбомной» ориентации), портретный → w_mm/h_mm (печать в «портретной»).
 */
export function printCropAspectForImg(printSize, naturalW, naturalH, rotate) {
    if (!printSize || !naturalW || !naturalH) {
        return 1;
    }
    const landscape =
        naturalW >= naturalH || (rotate && naturalW === naturalH);
    return landscape
        ? printSize.height / printSize.width
        : printSize.width / printSize.height;
}

/**
 * Naturals для aspect/enforce после «Повернуть» в модалке кропа: там берутся nh,nw вместо nw,nh.
 */
export function naturalSizeForModalCropFrame(imgEl, cropModalNaturalSwap) {
    if (!imgEl || imgEl.naturalWidth < 1 || imgEl.naturalHeight < 1) {
        return {naturalW: 1, naturalH: 1};
    }
    const nw = imgEl.naturalWidth;
    const nh = imgEl.naturalHeight;
    if (cropModalNaturalSwap) {
        return {naturalW: nh, naturalH: nw};
    }
    return {naturalW: nw, naturalH: nh};
}

/** Фактическое width/height рамки кропа в пикселях layout (как у getBox). */
export function layoutCropPixelAspect(crop, layoutW, layoutH) {
    if (!crop || !layoutW || !layoutH) {
        return null;
    }
    const u = crop.unit || "%";
    if (u === "px" && Number(crop.width) > 0 && Number(crop.height) > 0) {
        return Number(crop.width) / Number(crop.height);
    }
    if (u === "%" && Number(crop.width) > 0 && Number(crop.height) > 0) {
        const pw = (Number(crop.width) / 100) * layoutW;
        const ph = (Number(crop.height) / 100) * layoutH;
        return ph > 0 ? pw / ph : null;
    }
    return null;
}

/**
 * В «Без полей» пропорция рамки должна совпадать с printCropAspectForImg по ориентации кадра.
 * Иначе — центрированный кроп с нужным aspect в %.
 */
export function enforcePrintCropAspectCrop({
    crop,
    layoutW,
    layoutH,
    printSize,
    naturalW,
    naturalH,
    rotate,
    relativeTol = 0.015,
}) {
    const expected = printCropAspectForImg(printSize, naturalW, naturalH, rotate);
    if (!layoutW || !layoutH || !printSize || expected <= 0) {
        return crop;
    }
    const actual = layoutCropPixelAspect(crop, layoutW, layoutH);
    if (actual == null) {
        return centerCrop(
            makeAspectCrop({unit: "%", width: 100}, expected, layoutW, layoutH),
            layoutW,
            layoutH
        );
    }
    const relErr = Math.abs(actual - expected) / Math.max(expected, actual, 1e-9);
    if (relErr <= relativeTol) {
        return crop;
    }
    return centerCrop(
        makeAspectCrop({unit: "%", width: 100}, expected, layoutW, layoutH),
        layoutW,
        layoutH
    );
}
